/**
 * External dependencies
 */
import React from 'react';
import { Box, Heading } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Header = ({ children, heading, className, ...rest }) => {
    const classes = classnames('card__header');
    return (
        <Box className={classes}>
            {heading && <Heading level='3'>{heading}</Heading>}
            {children}
        </Box>
    );
};

export default Header;
